
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buero/portrait",
      function () {
        return require("private-next-pages/buero/portrait/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buero/portrait"])
      });
    }
  